import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import Form from "./CreateForm";
import plusIcon from "images/icons/invite/plus-simple.svg";

export default function Button({ isPossibleAddClaim }) {
  const [show, setShow] = useState(false);

  const closeForm = () => setShow(false);
  const openForm = () => {
    if (isPossibleAddClaim) {
      setShow(true);
    }
  };

  let modalHeader = "File A New Claim";

  return (
    <>
      <a
        className={`button-add ml20 ${isPossibleAddClaim ? "" : "disabled"}`}
        data-toggle={isPossibleAddClaim ? "" : "tooltip"}
        title={
          isPossibleAddClaim
            ? null
            : "There are no members eligible for Talent Insurance Claim at this time."
        }
        onClick={openForm}
      >
        <img src={plusIcon} />
      </a>

      <Modal
        className="student inmodal auto without-overflow"
        show={show}
        onHide={closeForm}
      >
        <Modal.Header closeButton>
          <Modal.Title>{modalHeader}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form closeForm={closeForm} />
        </Modal.Body>
      </Modal>
    </>
  );
}
